import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { AgeRangesDataService, AgeRangesColumnsService } from '../../../services';
import { AgeRange, AgeRangesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-age-range-details',
  templateUrl: './age-range-details.component.html',
  styleUrls: ['./age-range-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class AgeRangeDetailsComponent implements OnInit, OnDestroy {

  public ageRange: AgeRange = {};
  public ageRanges: AgeRange[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ageRangesDataService: AgeRangesDataService,
    private ageRangesColumnsService: AgeRangesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Age Range - Details');
        this.getAgeRange(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ageRange !== 'undefined') {
      this.ageRange = this.dynamicDialogConfig.data.ageRange;
    }
    this.columns = this.ageRangesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getAgeRange(id: number): void {
    this.isLoading = true;
    this.ageRangesDataService.getAgeRange(id).subscribe((response: AgeRange|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ageRange = response;
      }
    });
  }

  list() {
    this.router.navigate(['/age-ranges']);
  }

  add() {
    this.router.navigate(['/age-ranges/add']);
  }

  edit() {
    this.router.navigate(['/age-ranges/edit/' + this.ageRange.id]);
  }

}
@Component({
  selector: 'app-age-range-details',
  templateUrl: './age-range-details.component.html',
  styleUrls: ['./age-range-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogAgeRangeDetailsComponent extends AgeRangeDetailsComponent {
}

